import { WEB_SDUI_CATEGORY_PAGE_NAVIGATION_PATHS } from "@faire/web-api--source/indigofair/settings/WEB_SDUI_CATEGORY_PAGE_NAVIGATION_PATHS";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingSDUICategoryPagePathNavigationPaths = () =>
  getSettingValueWithoutAssignment(WEB_SDUI_CATEGORY_PAGE_NAVIGATION_PATHS, []);
